// extracted by mini-css-extract-plugin
export default {"subText":"terms_subText__zx55O","mainCont":"terms_mainCont__ZcoJ1","contentStyling":"terms_contentStyling__+MeQ-"};